import { TextField, Button, Box, IconButton } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { KWireInputProps } from './KWireTypes'
import { KWireInputLogic } from './KWireInput.logic'
import './KWireInput.scss'

export function KWireInput({ items, onAddItem }: KWireInputProps) {
  const {
    selectedValue,
    count,
    handleSelectChange,
    handleCountChange,
    incrementCount,
    decrementCount,
    handleAddClick,
    getMaxCount,
  } = KWireInputLogic({ items, onAddItem })

  return (
    <Box className="kwire-input-container">
      <div className="kwire-select-container">
        <select
          id="kwire-select"
          value={selectedValue}
          onChange={handleSelectChange}
          className="kwire-select-element"
        >
          <option value="">Select an item</option>
          {items.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>

      {selectedValue && (
        <Box className="kwire-quantity-container">
          <Box className="kwire-count-controls">
            <IconButton
              onClick={decrementCount}
              disabled={count <= 1}
              size="small"
              className="count-button"
            >
              <RemoveIcon />
            </IconButton>

            <TextField
              type="number"
              value={count}
              onChange={handleCountChange}
              inputProps={{ min: 1, max: getMaxCount() }}
              className="count-input"
              variant="outlined"
              size="small"
              label="Quantity"
            />

            <IconButton
              onClick={incrementCount}
              disabled={count >= getMaxCount()}
              size="small"
              className="count-button"
            >
              <AddIcon />
            </IconButton>
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={handleAddClick}
            disabled={!selectedValue}
            className="add-button"
            startIcon={<AddIcon />}
          >
            Add Item
          </Button>
        </Box>
      )}
    </Box>
  )
}
